/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Deductible } from './deductible';
import { NcdClass } from './ncdClass';
import { SpecialEquipmentAmount } from './specialEquipmentAmount';
import { Price } from './price';
import { NcdClassReason } from './ncdClassReason';

/**
 * Represents a motor vehicle fully comprehensive insurance.   (german: Kfz Vollkasko)   (bipro-kraftfahrt::Fahrzeugvollversicherung)
 */
export interface FullyComprehensiveInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
  ncdClassFullyComprehensive?: NcdClass;
  ncdClassReason?: NcdClassReason;
  /**
   * This avoids the downgrade of the NCD class in case of damages.   (german: Rabattretter, Nix-Passiert-Tarif)
   */
  ncdClassProtection?: boolean;
  deductibleFullyComprehensive?: Deductible;
  deductiblePartialComprehensive?: Deductible;
  specialEquipment?: SpecialEquipmentAmount;
}
export namespace FullyComprehensiveInsurance {}
